module.exports = __webpack_public_path__ + "static/media/front-end-online-store.08ef45f0.mp4";